<template>
  <ul class="item">
    <li class="item__list" v-for="(item, index) in movieList" :key="index">
      <a :href="`/movie/custom/${item.planning_id}`" class="item__list__link">
        <img
          :src="item.pack_image"
          class="item__list__link__image"
        >
        <div class="item__list__link__detail">
          <p class="item__list__link__detail__title">{{item.item_name}}</p>
          <p class="item__list__link__detail__description">占い師：{{item.counselor_name}}</p>
          <ul class="item__list__link__detail__tag">
            <li class="item__list__link__detail__tag__list">占いビデオレター</li>
          </ul>
          <p class="item__list__link__detail__price">
            ¥{{item.price_taxin}}
            <span>(税込)</span>
          </p>
        </div>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'uragei-list',
  props: {
    id: {
      type: Number,
      default: 24
    }
  },
  data() {
    return {
      movieList: [],
      styleObject: {
        display: 'none'
      }
    };
  },
  mounted() {
    const planning_id = [4, 1];
    axios.post(`/api/items/uragei?id=${this.id}`).then(res => {
      this.movieList = res.data.data_list;
    });
  },
  methods: {
    clickOpen() {
      const listitem = this.$refs.listItem;
      Object.keys(listitem).forEach(function(elm) {
        listitem[elm].style.display = 'block';
      });
      this.$refs.btnshowmoreMovie.style.display = 'none';
    }
  }
};
</script>

<style lang="scss">
@import '../../../sass/variables/colors.scss';
@import '../../../sass/functions/breakpoint.scss';

.item {
  margin: 0;
  padding: 0;
  list-style: none;
  &__list {
    position: relative;
    &:nth-of-type(n + 2) {
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        width: calc(100% - 32px);
        height: 1px;
        background: $gray-10;
        transform: translate(-50%, 0);
      }
    }
    &__link {
      position: relative;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 12px;
      text-decoration: none;
      &__image {
        display: block;
        width: 144px;
        border-radius: 6px;
      }
      &__detail {
        width: calc(100% - 156px);
        padding-top: 8px;
        &__title {
          line-height: 1.23;
          font-size: 13px;
          font-weight: bold;
        }
        &__description {
          line-height: 1.25;
          margin-top: 4px !important;
          font-size: 12px;
          color: $text-sub;
        }
        &__tag {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin: 4px 0 0;
          padding: 0;
          list-style: none;
          &__list {
            min-width: 86px;
            line-height: 16px;
            margin: 0 4px 4px 0;
            padding: 0 6px;
            font-size: 10px;
            text-align: center;
            border: 1px solid black;
            &:last-child {
              margin-right: 0;
            }
            @include breakpoint(mobileonly) {
              min-width: auto;
            }
          }
        }
        &__price {
          position: absolute;
          right: 12px;
          bottom: 12px;
          font-size: 16px;
          font-weight: bold;
          color: $brand-2;
          span {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/UrageiList.vue